import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 导入Element Plus暗色主题
import 'element-plus/theme-chalk/dark/css-vars.css'
// 全量导入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/main.css'

const app = createApp(App)

// 全局注册所有Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)
app.use(ElementPlus, { 
  size: 'default', 
  zIndex: 3000
})

// 添加暗色模式类名到HTML
document.documentElement.classList.add('dark')

app.mount('#app')
